import { render, staticRenderFns } from "./Dock.vue?vue&type=template&id=31286799&scoped=true"
import script from "./Dock.vue?vue&type=script&lang=js"
export * from "./Dock.vue?vue&type=script&lang=js"
import style0 from "./Dock.vue?vue&type=style&index=0&id=31286799&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31286799",
  null
  
)

export default component.exports